var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2 8.1a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4zM7.2 9.9a5.4 5.4 0 0 1 5.4 5.4H1.8a5.4 5.4 0 0 1 5.4-5.4zM14.4 6.3a.9.9 0 1 0-1.8 0v.9h-.9a.9.9 0 0 0 0 1.8h.9v.9a.9.9 0 0 0 1.8 0V9h.9a.9.9 0 1 0 0-1.8h-.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.315f3310dc4ee034d44ff7d56e47b88c.svg";
export { ForwardRef as ReactComponent };